/**
 * Carga automática de módulos sin convenciones de nombres.
 * solo se necesita un index en store con la exportación de cada uno de los elementos.
 * @see {@link src/febos/global/kanban/store/index.js|kanban store index}
 *
 * @typedef StoreIndexFile
 * @type {object}
 * @property {string} default nombre del módulo
 * @property {object} actions
 * @property {object} getters
 * @property {object} mutations
 * @property {object} state
 * @type {StoreIndexFile}
 */
export default function loadStoreModules() {
  const storeIndexFiles = require.context('../../febos/', true, /store\/index.js$/);
  return storeIndexFiles.keys().reduce((index, file) => {
    const {
      default: name,
      actions = {},
      getters = {},
      mutations = {},
      state = {}
    } = storeIndexFiles(file);

    if (!name) {
      return index;
    }

    const moduleSettings = {
      namespaced: true,
      actions,
      getters,
      mutations,
      state
    };

    return { ...index, [name]: moduleSettings };
  }, {});
}
